export const SUPPORT_FAQ_SECTIONS = [
  {
    type: 'platform',
    title: 'Sobre Flotte',
    description: 'Conoce el alcance de la plataforma y como cuidamos la informacion de tu empresa.',
    entries: [
      {
        question: 'Que es Flotte y para quien esta disenada?',
        answer:
          'Flotte es una plataforma SaaS para operadores logisticos y flotas corporativas. Centraliza la gestion de unidades, publicaciones en el marketplace y la relacion comercial B2B.',
      },
      {
        question: 'Que modulos incluye mi suscripcion base?',
        answer:
          'Todas las cuentas incorporan panel de control, gestor de unidades, publicaciones, seguimiento de oportunidades y el centro de soporte colaborativo.',
      },
      {
        question: 'Donde se hospedan los datos y que controles existen?',
        answer:
          'Operamos sobre AWS (region us-east-1) con copias redundantes, cifrado en reposo (AES-256) y en transito (TLS 1.2). Los accesos privilegiados se auditan cada 24 horas.',
      },
      {
        question: 'Puedo conectar Flotte con mis sistemas internos?',
        answer:
          'Si. Contamos con API REST y webhooks para altas de unidades, publicaciones y estados de oportunidad. Solicita tus credenciales desde Soporte -> Integraciones.',
      },
    ],
  },
  {
    type: 'onboarding',
    title: 'Implementacion y equipo',
    description: 'Acelera el despliegue de Flotte y mantiene a tu organizacion alineada.',
    entries: [
      {
        question: 'Cuanto tarda el onboarding completo?',
        answer:
          'El proceso estandar toma 5 dias habiles: 1 para configurar la empresa, 2 para importar unidades y 2 adicionales para publicar el inventario inicial.',
      },
      {
        question: 'Como invito a mi equipo operativo y comercial?',
        answer:
          'En Empresa -> Usuarios utiliza "Invitar colaborador". Define el rol (Administrador, Operaciones, Comercial o Solo lectura) antes de enviar el correo automatico.',
      },
      {
        question: 'Que ocurre si un colaborador ya no requiere acceso?',
        answer:
          'Puedes suspenderlo desde la misma pantalla. Conservamos su historial para auditoria y puedes reactivarlo sin costo cuando lo necesites.',
      },
      {
        question: 'Ofrecen capacitacion para nuevos usuarios?',
        answer:
          'Incluimos dos sesiones virtuales al mes y microlecciones on-demand dentro de la seccion Recursos para que cada equipo avance a su ritmo.',
      },
    ],
  },
  {
    type: 'operations',
    title: 'Operaciones y seguimiento',
    description: 'Mantente al dia con flujos diarios, alertas y colaboracion entre equipos.',
    entries: [
      {
        question: 'Puedo recibir alertas cuando cambia el estado de una unidad?',
        answer:
          'Activa las notificaciones en Configuracion -> Preferencias. Puedes elegir alertas dentro de la app o por correo para disponibilidad, comentarios y documentos.',
      },
      {
        question: 'Como comparto una publicacion con mi equipo comercial?',
        answer:
          'Abre la publicacion y selecciona "Compartir". Genera un enlace con fecha de expiracion o envia un resumen PDF directamente desde Flotte.',
      },
      {
        question: 'Existe una forma de duplicar una publicacion similar?',
        answer:
          'Si. En el menu de acciones elige "Duplicar". Creamos un borrador con los mismos campos para que solo ajustes precio, fechas o multimedia.',
      },
      {
        question: 'Que tablero puedo usar para ver negociaciones activas?',
        answer:
          'Dashboard -> Feed muestra solicitudes, respuestas y actividades del equipo en tiempo real. Filtra por etiqueta, cliente o estado para priorizar.',
      },
    ],
  },
  {
    type: 'publications',
    title: 'Publicaciones y unidades',
    description: 'Administra inventario, disponibilidad y contenido comercial.',
    entries: [
      {
        question: 'Como publico una nueva unidad?',
        answer:
          'Ve a Publicaciones y presiona "Nueva publicacion". Completa datos tecnicos, tarifas y disponibilidad, guarda el borrador y publícalo cuando este listo.',
      },
      {
        question: 'Que pasa si una unidad se encuentra ocupada temporalmente?',
        answer:
          'Actualiza la disponibilidad desde Unidades -> Calendario. El sistema bloquea nuevas solicitudes durante ese periodo pero conserva el historial.',
      },
      {
        question: 'Puedo programar la publicacion para una fecha futura?',
        answer:
          'Si. En el paso Disponibilidad define el rango de activacion. Flotte publica y desactiva automaticamente la unidad en las fechas indicadas.',
      },
      {
        question: 'Como agrego multimedia o fichas tecnicas?',
        answer:
          'En la seccion Banner y Documentos puedes subir URLs de imagen, video o enlaces a fichas PDF. Tambien puedes usar el banner corporativo por defecto.',
      },
    ],
  },
  {
    type: 'billing',
    title: 'Facturacion y pagos',
    description: 'Controla comprobantes digitales, renovaciones y metodos de pago.',
    entries: [
      {
        question: 'Donde consulto mis comprobantes?',
        answer:
          'En Empresa -> Documentos encuentras todos los CFDI emitidos y puedes cargar evidencia complementaria para conciliaciones internas.',
      },
      {
        question: 'A quien contacto si detecto un cargo incorrecto?',
        answer:
          'Crea un ticket desde Soporte -> Nuevo seleccionando la categoria "Facturacion". Respondemos en menos de 24 horas habiles.',
      },
      {
        question: 'Puedo descargar un detalle de pagos pendientes?',
        answer:
          'Si. Desde Empresa -> Facturacion haz clic en "Exportar resumen" para generar un CSV con saldos, vigencias y referencias.',
      },
      {
        question: 'Que metodos de pago acepta la plataforma?',
        answer:
          'Aceptamos transferencia SPEI, tarjeta corporativa y pagos programados via convenio bancario. Para domiciliacion recurrente escribe a billing@flotte.app.',
      },
    ],
  },
  {
    type: 'support',
    title: 'Soporte tecnico',
    description: 'Obtén ayuda especializada, seguimiento y canales de respaldo.',
    entries: [
      {
        question: 'Como reporto un problema urgente fuera del horario laboral?',
        answer:
          'Crea un ticket marcando prioridad "Alta". Nuestro sistema de guardias notifica al equipo on-call y recibirás actualizaciones por correo.',
      },
      {
        question: 'Puedo adjuntar capturas o archivos en un ticket?',
        answer:
          'Por ahora comparte enlaces seguros (Drive, Dropbox, OneDrive) dentro de la descripcion del ticket. El equipo revisa los adjuntos antes de responder.',
      },
      {
        question: 'Donde consulto el estatus de mis tickets abiertos?',
        answer:
          'En Soporte -> Mis tickets veras fechas, prioridad, propietario y comentarios. Puedes filtrar por estado o descargar el historial en CSV.',
      },
      {
        question: 'Cuentan con un canal directo para clientes enterprise?',
        answer:
          'Si. Los planes Enterprise incluyen un canal dedicado en Slack Connect con Customer Success para escalar bloqueos sin abrir un ticket.',
      },
    ],
  },
];
